export default __webpack_public_path__ + "static/media/compas_project_formation_cursus.397c0a36.gif";